import { render, staticRenderFns } from "./ArticlePreview.vue?vue&type=template&id=0d7f2150&"
import script from "./ArticlePreview.vue?vue&type=script&lang=coffee&"
export * from "./ArticlePreview.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports